module.exports = __webpack_public_path__ + "static/media/logo_sh.edadee9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/installfest/resources/sponsors/logo_sh.png
// module id = 394
// module chunks = 0